import styled from 'styled-components';

export const Card = styled.div`
  background: white;
  padding: 6px 24px;
  margin-bottom: 12px;
`;
